import React, {PureComponent, ReactNode} from "react"
import styled from "styled-components"

import {H2} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import Badge from "@irati/ui/src/Badge"

import {BadgeCount} from "./AdminHeader"

const StyledFlex = styled(Flex)`
  min-width: 200px;
`

const StyledH2 = styled(H2)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  word-break: break-all;
  max-width: 250px;
  ${theme.mediaQueries.minWidthMedia.desktop`
    max-width: 400px;
  `}
`

interface Props {
  title?: string | ReactNode
  infoCount?: number | string | ReactNode
  errorCount?: number | string | ReactNode
  successCount?: number | string | ReactNode
  multiCounts?: BadgeCount[]
  marginBottom?: number
}

class HeaderTitle extends PureComponent<Props> {
  getMultiCountColor = (type) => {
    switch (type) {
      case "info":
        return theme.colors.primary2
      case "success":
        return theme.colors.perkbox.greenBlue
      case "error":
        return theme.colors.tertiary.r_400
      default:
        return theme.colors.primary2
    }
  }

  render() {
    const {title, infoCount, errorCount, successCount, marginBottom, multiCounts} = this.props

    return (
      <StyledFlex alignItems="baseline">
        <StyledH2 marginBottom={marginBottom || 4}>{title}</StyledH2>
        {infoCount && (
          <Badge bgColor={theme.colors.primary2} color={theme.colors.greys.white} padding={[0, 1]} margin={[0, 1]}>
            {infoCount}
          </Badge>
        )}
        {errorCount && (
          <Badge
            bgColor={theme.colors.tertiary.r_400}
            color={theme.colors.greys.white}
            padding={[0, 1]}
            margin={infoCount ? [0, 1, 0, 0] : [0, 1]}>
            {errorCount}
          </Badge>
        )}
        {successCount && (
          <Badge bgColor={theme.colors.perkbox.greenBlue} color={theme.colors.greys.white} padding={[0, 1]}>
            {successCount}
          </Badge>
        )}
        {multiCounts &&
          multiCounts.length > 0 &&
          multiCounts.map((item: BadgeCount, index: number) => {
            return (
              item.count && (
                <Badge
                  key={index}
                  bgColor={this.getMultiCountColor(item.type)}
                  color={theme.colors.greys.white}
                  padding={[0, 1]}
                  margin={infoCount || errorCount || successCount ? [0, 1, 0, 0] : [0, 1]}>
                  {item.count}
                </Badge>
              )
            )
          })}
      </StyledFlex>
    )
  }
}

export default HeaderTitle
